import React from 'react';
import { CONCLAVE_AUDIENCE, CONCLAVE_TOPICS } from './data';
import { ConvergeSpeakers } from './ConvergeSpeakers';
import { ConvergeRsvp } from './ConvergeRsvp';

export const ConvergeConclave = () => (
  <section id="hr-conclave" className="scroll-mt-20 bg-[#FF6338] border-b-2 border-[#111] relative overflow-hidden" data-testid="conclave-section">
    <div className="absolute -right-10 top-10 cv-display font-extrabold text-[220px] leading-none text-[#111]/[0.08] select-none pointer-events-none hidden md:block" aria-hidden="true">HR</div>
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
      <div className="flex flex-wrap items-center gap-3">
        <span className="bg-[#111] text-[#FF6338] px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.2em]" data-testid="conclave-name">CONVERGE HR Conclave</span>
        <span className="bg-[#F5F3EB] border-2 border-[#111] px-3 py-1 text-[11px] font-extrabold uppercase tracking-wider" data-testid="conclave-schedule">17 November 2026 | 4:00 PM – 7:00 PM</span>
      </div>
      <h2 className="cv-display font-extrabold uppercase leading-[0.88] mt-6 text-[2.1rem] sm:text-6xl lg:text-7xl xl:text-8xl max-w-6xl break-words" data-testid="conclave-title">The future of work is converging.</h2>
      <div className="mt-12 grid lg:grid-cols-3 gap-6">
        <div className="bg-[#F5F3EB] border-2 border-[#111] shadow-[6px_6px_0_#111] p-6 lg:col-span-1" data-testid="conclave-audience">
          <p className="text-[11px] font-bold uppercase tracking-[0.25em]">Who it's for</p>
          <ul className="mt-4 space-y-2">
            {CONCLAVE_AUDIENCE.map((a) => <li key={a} className="text-sm font-medium flex gap-2"><span className="font-extrabold text-[#FF6338]">■</span>{a}</li>)}
          </ul>
        </div>
        <div className="bg-[#111] text-[#F5F3EB] border-2 border-[#111] shadow-[6px_6px_0_#F5F3EB] p-6 lg:col-span-2" data-testid="conclave-topics">
          <p className="text-[11px] font-bold uppercase tracking-[0.25em] text-[#FF6338]">On the agenda</p>
          <ol className="mt-4 grid sm:grid-cols-2 gap-x-6">
            {CONCLAVE_TOPICS.map((t, i) => (
              <li key={t} className="flex gap-3 py-3 border-b border-[#F5F3EB]/15">
                <span className="cv-display font-extrabold text-[#FF6338]">{String(i + 1).padStart(2, '0')}</span><span className="text-sm font-medium">{t}</span>
              </li>
            ))}
          </ol>
        </div>
      </div>
      <ConvergeSpeakers />
      <ConvergeRsvp />
    </div>
  </section>
);
